import Modal from 'react-modal';
import React, { useEffect, useState } from 'react';
import { Car } from '@upstart/harmony/lib/legos/carTypes';
import { amplitudeEvents } from 'util/amplitudeEvents';
import './UpdateMileageModal.scss';
import Input from '../PencilEditor/Input';
import { useCarMutation } from '../../hooks/useCarMutation';

interface UpdateMileageModalProps {
  car?: Car;
  handleClose(): void;
  sendAmplitudeEvent?: (event: string) => void;
}

const MODAL_STYLE = {
  content: {
    margin: '0 auto',
    maxWidth: '500px',
    position: 'relative' as const,
  },
};

export function UpdateMileageModal({
  car,
  handleClose,
  sendAmplitudeEvent,
}: UpdateMileageModalProps) {
  const [updatedMileage, setMileage] = useState('');
  useEffect(() => {
    if (car) {
      setMileage(car?.mileage?.toString() || '0');
    }
  }, [car]);
  const { mutate } = useCarMutation();

  const handleUpdate = () => {
    mutate({ id: car!.id, mileage: updatedMileage });
    if (sendAmplitudeEvent) {
      sendAmplitudeEvent(amplitudeEvents.DESKING_PENCIL_MILEAGE_FINISH);
    }
    handleClose();
  };

  return (
    <Modal isOpen={!!car} style={MODAL_STYLE}>
      <div className={'update-mileage-modal'}>
        <h3 className="capitalize-in-chairman">Set mileage</h3>
        <p>
          Updating mileage can affect protection plan eligibility, check current
          protection plan selections
        </p>
        <b className="inline-block pb-5">Enter New Mileage:</b>
        <div>
          <Input
            value={updatedMileage}
            onChange={(value: string) => setMileage(value.replace(/\D/gi, ''))}
          />
          Miles
        </div>
        <div className="mileage-row">
          <button
            className="btn btn-default cc-button-outlined uppercase-in-chairman"
            type="button"
            onClick={() => {
              if (sendAmplitudeEvent) {
                sendAmplitudeEvent(
                  amplitudeEvents.DESKING_PENCIL_MILEAGE_CANCEL,
                );
              }

              handleClose();
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary cc-button-primary uppercase-in-chairman"
            type="submit"
            onClick={handleUpdate}
          >
            Apply and save
          </button>
        </div>
      </div>
    </Modal>
  );
}
